import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"


const CloseCurrentTab = () => {
    window.close()
    return (<div>
        
        <FormattedMessage
            id="auth.close_tab_message"
            defaultMessage="Please close this tab and return to pipedrive to install."
        />
    </div>)
}

export default injectIntl(CloseCurrentTab)


// WEBPACK FOOTER //
// ./src/auth/components/CloseCurrentTab.tsx